<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { Button } from "@components";

import { useAppointments } from "@store/appointments.js";
const $appointments = useAppointments();

import { useSettings } from "@store/settings.js";
const $settings = useSettings();

import { useCustomizer } from "@store/customizer.js";
const $customizer = useCustomizer();

import ServiceLoader from "./ServiceLoader.vue";
import ServiceItem from "./ServiceItem.vue";
import Main from "@views/booking/layout/Main.vue";
import { isSm } from "../../../../utilities/mediaQuery";
import Icon from "@components/Icon.vue";

onMounted(async () => {
  // console.log('service')
  await $appointments.fetchServices();
});
const filterServices = computed(() => {
  return $appointments.getServices || [];
});

const wrapperClass = computed(() => {
  if (isSm) return "service-list-wrapper-row";
  switch ($settings.customizer.service.layout_type) {
    case "row01":
      return "service-list-wrapper-row";
    case "grid01":
      return "service-list-wrapper-grid";
    default:
      return "service-list-wrapper-row";
  }
});

const submitService = (service_id, btnClick = false) => {
  if (!service_id) return;
  $appointments.setAppointment(
    "service_id",
    service_id,
    $settings.isWidget && !btnClick ? false : true
  );

  // bail if widget but no button click
  // if ($settings.isWidget && !btnClick) return

  // $appointments.nextStep()
};

// set service when there is only one
watch(
  () => filterServices,
  () => {
    if (filterServices.value.length == 1) {
      submitService(filterServices.value[0].service_id);
    }
  },
  { deep: true }
);

const showBackButton = computed(() => {
  return $settings.isWidget || isSm;
});
</script>

<template>
  <Main>
    <template #content>
      <div class="flex items-center gap-1 mb-5">
        <!-- <Icon name="chevronLeft" class="cursor-pointer" :class="{'hidden': !showBackButton}" size="24px" @click="$appointments.prevStep()" /> -->
        <div class="service-page-title" :style="$customizer.titleStyle">
          {{ $settings.customizer.service.title || "" }}
        </div>
      </div>
      <!-- empty service loader -->
      <ServiceLoader v-if="!$appointments.isServiceLoaded" />

      <!-- service list -->
      <div v-if="$appointments.isServiceLoaded" :class="wrapperClass">
        <ServiceItem
          v-for="(service, index) in filterServices"
          :key="index"
          :service="service"
          @select="(service) => submitService(service.service_id)"
        />
      </div>
    </template>

    <template #footer v-if="$settings.isWidget">
      <Button
        @click="submitService($appointments.selectedService.service_id, true)"
        type="primary"
        size="md"
        radius="square"
        class="w-full"
        >Continue</Button
      >
    </template>
  </Main>
</template>
